module.exports = __webpack_public_path__ + "img/DEE8DE_A6B5A6_BCCCBC_BCC4BC-256px.ebd5d5c9.png";